<button class="btn btn-sm btn-lmr-primary ps-1 h-100"
        type="submit"
        [disabled]="disabled"
        title="Search" i18n-title="@@search.button"
        (click)="onButtonClick($event)">
  <i class="fa fa-search" aria-hidden="true"></i>&nbsp;
  <span class="d-none" i18n="@@search.button">Search</span>
</button>
